namespace GeniuzPOS.InventoryReport {
    export interface IcReport08HdDtReportData extends Serenity.ListRequest {
        Header?: IcReport08Row;
        Details?: IcReport08DtRow[];
        SkuCode?: string;
    }
}
